import React, { Component } from 'react';
import ContentBox from './ContentBox.js';
import ClientSelectCilindro from './ClientSelectCilindro';
import { userIsClient, getDiscount } from '../api.js';

import DesktopBaner from '../img/descuento-cilindro-Desktop.jpg';
import MobileBaner from '../img/descuento-cilindro-mobile.jpg';
const whatsappLink = "https://api.whatsapp.com/send?phone=56229381232&text=Hola%20Abastible%20%F0%9F%8F%A0";

export default class ServiciosCilindroDescuentos extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isClient: false,
			discounts: [],
			addressSelected: null,
			internalError: false,
			searchDiscount: false,
			dataNotFound: false,
			showDiscount: false,
			selectedService: null,
			showTerms: false,
			showCheckDiscount: false,
			isLoading: true,
			isLoadingDiscount: false,
			cylinderProduct: "0",
			cylinderMount: "desc",
			discountsAvailable: 0,
		};
	}

	getUserIsClient() {
		userIsClient((error, result) => {
			if (error) {
				this.setState({ internalError: true });
			}
			this.setState({ isClient: result.code === 200 ? true : false });
			this.setState({ isLoading: false });
		});
	}

	getDiscounts(commune) {
		this.setState({ isLoadingDiscount: true });
		this.setState({ showDiscount: false });
		this.setState({ internalError: false });
		this.setState({ searchDiscount: false });
		this.setState({ dataNotFound: false });
		getDiscount({ "commune": commune, "cylinder": parseInt(this.state.cylinderProduct), "amountOrder": this.state.cylinderMount }, (error, result) => {
			if (error) {
				this.setState({ internalError: true });
				return;
			}
			if (result?.code === 200) {
				this.setState({ discounts: result.discounts });
				this.setState({ showDiscount: true });
				this.setState({ showCheckDiscount: true });
				this.setState({ discountsAvailable: result.discountsAvailable });
				this.setState({ internalError: false });
				this.setState({ searchDiscount: false });
				this.setState({ dataNotFound: false });
			} else {
				this.setState({ searchDiscount: result?.code === 204 ? true : false });
				this.setState({ dataNotFound: result?.code === 404 ? true : false });
				this.setState({ showDiscount: false });
				this.setState({ showCheckDiscount: false });
				this.setState({ discountsAvailable: 0 });
			}
			this.setState({ isLoadingDiscount: false });
		});
	}

	handleServiceChange = (serviceId) => {
		this.setState({
			selectedService: serviceId
		});
		this.getDiscounts(serviceId.client_city);
	};

	componentDidMount() {
		this.getUserIsClient();
	}

	filter() {
		this.getDiscounts(this.state.selectedService.client_city);
	}

	render() {
		return (
			<ContentBox loading={this.state.isLoading || this.state.isLoadingDiscount}>
				{(this.state.isLoading || this.state.isLoadingDiscount) && <div style={ {height:'8rem'} } /> }

				{!this.state.isClient && !this.state.isLoading &&
					<a href={whatsappLink} target='blank' onClick={this.onClickwhatsappLink}>
						<picture>
							<source media="(max-width:780px)" srcSet={MobileBaner} />
							<img src={DesktopBaner} alt='imagen de descuento en servicio cilindro' width={"100%"} />
						</picture>
					</a>
				}
				{this.state.isClient && !this.state.isLoadingDiscount && <>
					<div className="title-client-container mobile-cilindro-descuento clearfix">
						<h1>
							Mis Descuentos
							<br/>
							<p className='title-client-container-subtitle mt-8 size-18'>
								Usa estos descuentos en tu próximo pedido desde la app o WhatsApp.
							</p>
						</h1>
						<div className="client-number">
							<ClientSelectCilindro
								clientAddresStyle={{ fontSize: 14, textTransform:'uppercase' }}
								placeholder="Selecciona Dirección"
								hideClientCode={true}
								services={this.props.services}
								selected={this.state.selectedService}
								setSelectedService={this.handleServiceChange} />
						</div>
					</div>

					{this.state.selectedService && !this.state.dataNotFound && <>
						<InfoBlockDiscount>
							Podrás utilizar ({this.state.discountsAvailable}) descuentos máximo por mes
						</InfoBlockDiscount>
						<form className='grid-column-3 mobile:gap-8 mt-24' onSubmit={e => e.preventDefault()}>
							<select name='discount-cylinder-select-product'
								value={this.state.cylinderProduct}
								onChange={(e) => { this.setState({ cylinderProduct: e.target.value }) }} >
								<option value="0">
									Todos los cilindros
								</option>
								<option value="5">
									5 Kg
								</option>
								<option value="11">
									11 Kg
								</option>
								<option value="15">
									15 Kg
								</option>
								<option value="45">
									45 Kg
								</option>
							</select>
							<select name='discount-cylinder-select-mount'
								value={this.state.cylinderMount}
								onChange={(e) => { this.setState({ cylinderMount: e.target.value }) }} >
								<option value="desc">
									Monto (mayor a menor)
								</option>
								<option value="asc">
									Monto (menor a mayor)
								</option>
							</select>
							<button className="button orange" onClick={() => { this.filter() }}>
								Filtrar
							</button>
						</form>
					</>}


					{this.state.showDiscount && (
						<div className='grid-column-3 mt-24'>
							{this.state.discounts.map((discount, index) => (
								<CardCylinderDiscount
									key={'CardCylinderDiscount-' + index}
									isBestDiscount={discount.mejorDescuento}
									product={discount.name}
									amount={discount.monto.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}
									terms="Para aplicar este descuento en tu compra, ingresa desde la app o pide por WhatsApp."
								/>
							))}
						</div>
					)}

					{this.state.dataNotFound && 
						<div className='mt-92'>
							<AlertBlockDiscount iconType="warning">
								No tienes descuentos asociados a esta dirección
							</AlertBlockDiscount>
						</div>
					}
					{this.state.searchDiscount && 
						<div className='mt-92'>
							<AlertBlockDiscount iconType="warning" >
								No tienes descuentos asociados a esta búsqueda
							</AlertBlockDiscount>
						</div>
					}
					{this.state.internalError &&
						<div className='mt-92 '>
							<AlertBlockDiscount iconType="tool">
								Estamos presentando problemas de conexión. Inténtalo más rato.
							</AlertBlockDiscount>
						</div>
					}

					{this.state.showCheckDiscount && (
						<div className='card-cylinder-discount--container-terms mt-40' style={{ borderRadius: '4px', border: '1px solid #D9D9D9', padding: '12px 33px' }}>
							<div className='w-full d-flex flex-mobile flex-column-mobile items-center justify-between gap-4'>
								<div style={{ flex: 1 }}>
									<h2 style={{ margin: 0, fontWeight: '500', fontSize: '20px' }}>Canjear descuento</h2>
									<p className='mt-8' style={{ margin: 0, color: '#525252' }}>
										Para el canje de tu descuento debe ir a nuestro WhatsApp.
									</p>
								</div>
								<div>
									<a href='https://wa.me/56229381232' className='button orange h-fit-content'>
										Ir a WhatsApp
									</a>
								</div>
							</div>
						</div>
					)}

					{this.state.showTerms && (
						<p className='mt-24 card-cylinder-discount--block-terms font-12 color-gray'>
							Términos y Condiciones
							<br />
							Los descuentos son válidos para una sola compra, no es acumulable, no es canjeable por dinero y aplica según disponibilidad y vigencia. El comercio puede modificar o cancelar la promoción sin previo aviso.
						</p>
					)}
				</>}
			</ContentBox>
		);
	}
}



/**
* Componente que muestra un bloque informativo de descuentos disponibles.
*
* @class InfoBlockDiscount
* @extends Component
*
* @param {Object} props - Propiedades del componente.
* @param {React.ReactNode} props.children - Contenido del mensaje a renderizar dentro del bloque.
* @param {string} props.count - Cantidad de descuentos utilizados o disponibles (ej: "0/2").
*
* @example
*	<InfoBlockDiscount count="0/2">
*		Podrás utilizar (2) descuentos máximo por mes
*	</InfoBlockDiscount>
*/
class InfoBlockDiscount extends Component {

	render() {
		const { children, count } = this.props
		return (
			<div className='info-block'>
				<p>
					<svg
						width="14"
						height="14"
						viewBox="0 0 14 14"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M6.41666 4.08334H7.58332V5.25H6.41666V4.08334ZM6.41666 6.41667H7.58332V9.91667H6.41666V6.41667ZM6.99999 1.16667C3.77999 1.16667 1.16666 3.78 1.16666 7C1.16666 10.22 3.77999 12.8333 6.99999 12.8333C10.22 12.8333 12.8333 10.22 12.8333 7C12.8333 3.78 10.22 1.16667 6.99999 1.16667ZM6.99999 11.6667C4.42749 11.6667 2.33332 9.5725 2.33332 7C2.33332 4.42751 4.42749 2.33334 6.99999 2.33334C9.57249 2.33334 11.6667 4.42751 11.6667 7C11.6667 9.5725 9.57249 11.6667 6.99999 11.6667Z"
							fill="currentColor" />
					</svg>

					<span> {children} </span>
				</p>

				<span>
					{count}
				</span>
			</div>
		)
	}
}



/**
 * Componente que muestra una tarjeta con información sobre un descuento a cilindros.
 *
 * @class CardCylinderDiscount
 * @extends Component
 *
 * @param {Object} props - Propiedades del componente.
 * @param {boolean} props.isBestDiscount - Indica si este es el mejor descuento disponible.
 * @param {string} props.product - Tipo o presentación del cilindro (ej: "5 kg").
 * @param {string} props.amount - Monto del descuento o precio resultante.
 * @param {string} props.caption - Texto adicional mostrado debajo del monto.
 * @param {string} props.terms - Texto que explica los términos o condiciones del descuento.
 *
 * @example
 * <CardCylinderDiscount 
 *    isBestDiscount
 *    product="5 kg"
 *    amount="$5.000"
 *    caption="Descuento Caja los Andes Trabajadores"
 *    terms="Para aplicar este descuento en tu compra, ingresa desde la app o pide por WhatsApp."
 * />
 */
class CardCylinderDiscount extends Component {

	render() {
		const { isBestDiscount, product, amount, caption, terms } = this.props;
		return (
			<div className='card-cylinder-discount'>
				<div className='card-cylinder-discount--top'>
					<span className='card-cylinder-discount--top-badge'> {product} </span>

					{isBestDiscount &&
						<div className='card-cylinder-discount--top-best'>
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M11.0276 5.31169C11.0276 5.21427 10.9952 5.13398 10.9326 5.07181L10.0073 4.00411L10.1625 2.59619C10.1723 2.50856 10.1498 2.42387 10.095 2.34358C10.0377 2.26379 9.96476 2.21336 9.87762 2.19868L8.44962 1.90838L7.70943 0.655633C7.66439 0.575838 7.59683 0.520519 7.5092 0.490657C7.42158 0.463243 7.33688 0.46569 7.2517 0.505832L5.96861 1.09084L4.69335 0.504854C4.60572 0.464711 4.51809 0.462263 4.43095 0.495063C4.34332 0.524925 4.27577 0.582691 4.23073 0.662486L3.50278 1.90789L2.06254 2.19819C1.97491 2.21336 1.90246 2.2633 1.84518 2.34309C1.79035 2.42289 1.76783 2.50807 1.78252 2.5957L1.93232 4.00363L1.00708 5.07132C0.944419 5.13398 0.912109 5.21378 0.912109 5.3112C0.912109 5.40617 0.944419 5.48645 1.00708 5.55107L1.93232 6.62366L1.78252 8.03404C1.76734 8.12167 1.78986 8.20636 1.84518 8.28665C1.90246 8.36644 1.9754 8.41442 2.06254 8.43155L3.04407 8.62737V10.9488C3.04407 11.2205 3.15618 11.432 3.37794 11.5774C3.50767 11.6625 3.64621 11.7056 3.78965 11.7056C3.88903 11.7056 3.99232 11.6851 4.09904 11.643L5.96959 10.8308L7.84307 11.6439C7.94735 11.6851 8.05064 11.7056 8.15002 11.7056C8.29345 11.7056 8.43199 11.6625 8.56172 11.5774C8.78349 11.4315 8.89559 11.2205 8.89559 10.9488V8.62884L9.87713 8.43106C9.96476 8.41344 10.0372 8.36595 10.0945 8.28615C10.1493 8.20636 10.1718 8.12118 10.162 8.03355L10.0069 6.62317L10.9321 5.55058C10.9952 5.48645 11.0276 5.40666 11.0276 5.31169ZM4.06281 5.02628C4.12303 4.97145 4.19548 4.94355 4.27772 4.94648C4.36046 4.94648 4.43046 4.9788 4.48529 5.03901L5.4355 6.01957L7.47347 3.98894C7.5234 3.93901 7.58851 3.91159 7.66831 3.9062C7.74565 3.90376 7.81321 3.92628 7.86853 3.97621C7.93364 4.03642 7.9635 4.10643 7.9635 4.18867C7.96105 4.2714 7.93364 4.34141 7.88077 4.39624L5.69006 6.57667C5.61516 6.65157 5.52998 6.68926 5.43256 6.68926C5.33759 6.68926 5.25485 6.65157 5.1824 6.57667L4.06184 5.46149C3.99428 5.39882 3.95952 5.32637 3.95952 5.24413C3.9605 5.16384 3.99526 5.09139 4.06281 5.02628ZM8.47067 10.9248C8.47067 11.0487 8.4222 11.1407 8.32332 11.2058C8.26555 11.2435 8.20876 11.2616 8.14904 11.2616C8.10547 11.2616 8.05945 11.2513 8.01246 11.2308L5.96959 10.3555L3.92672 11.2308C3.87972 11.2513 3.8342 11.2616 3.79063 11.2616C3.73139 11.2616 3.67412 11.2435 3.61684 11.2058C3.51746 11.1407 3.46949 11.0487 3.46949 10.9248V8.71304L3.50327 8.71989L4.23122 9.9604C4.27626 10.0402 4.34381 10.0955 4.43144 10.1278C4.51907 10.1577 4.6067 10.1552 4.69384 10.118L5.9691 9.53302L7.25219 10.118C7.33737 10.1557 7.42207 10.1606 7.50969 10.1308C7.59732 10.1033 7.66488 10.048 7.70992 9.96823L8.45011 8.72038L8.47116 8.71597V10.9248H8.47067Z"
									fill="white" />
							</svg>

							<span> Mejor descuento </span>
						</div>
					}
				</div>

				<p className='card-cylinder-discount--center mt-20'>
					<strong>{amount}</strong>
				</p>

				{terms &&
					<p className='card-cylinder-discount--bottom mt-32'>
						{terms}
					</p>
				}
			</div>
		)
	}
}



/**
 * Componente que muestra un bloque de alerta o información, permitiendo elegir entre
 * diferentes íconos (tool o warning) y renderizando contenido personalizado mediante `children`.
 *
 * @class AlertBlockDiscount
 * @extends Component
 *
 * @param {Object} props - Propiedades del componente.
 * @param {"tool" | "warning" | null} [props.iconType] - Define el tipo de ícono a mostrar.
 *   Si no se envía, ningún ícono será renderizado.
 * @param {React.ReactNode} props.children - Contenido del mensaje a mostrar bajo el ícono.
 *
 * @example
 * // Ejemplo con ícono de advertencia:
 * <AlertBlockDiscount iconType="warning">
 *    No tienes descuentos asociados a esta dirección
 * </AlertBlockDiscount>
 *
 * @example
 * // Ejemplo con ícono de herramienta:
 * <AlertBlockDiscount iconType="tool">
 *    Estamos presentando problemas de conexión. Inténtalo más rato.
 * </AlertBlockDiscount>
 */

class AlertBlockDiscount extends Component {

	SvgPathWarning = () => (
		<path d="M11.6836 76.8748C11.1492 76.8748 10.6789 76.7492 10.2726 76.4979C9.86637 76.2467 9.55012 75.9154 9.32387 75.5042C9.08387 75.1254 8.95168 74.6992 8.92731 74.2254C8.90356 73.751 9.03387 73.2757 9.31824 72.7995L42.6829 15.2782C42.9629 14.8332 43.3001 14.5013 43.6945 14.2826C44.0882 14.0638 44.5232 13.9545 44.9995 13.9545C45.4757 13.9545 45.9107 14.0638 46.3045 14.2826C46.6989 14.5013 47.0361 14.8332 47.3161 15.2782L80.6807 72.7995C80.9651 73.2757 81.0954 73.751 81.0717 74.2254C81.0473 74.6992 80.9151 75.1254 80.6751 75.5042C80.4489 75.9154 80.1326 76.2467 79.7264 76.4979C79.3201 76.7492 78.8498 76.8748 78.3154 76.8748H11.6836ZM45.2836 66.9879C45.9523 66.9879 46.5073 66.7617 46.9486 66.3092C47.3898 65.8567 47.6104 65.296 47.6104 64.6273C47.6104 63.9579 47.3842 63.4029 46.9317 62.9623C46.4792 62.521 45.9182 62.3004 45.2489 62.3004C44.5801 62.3004 44.0251 62.5267 43.5839 62.9792C43.1432 63.4317 42.9229 63.9923 42.9229 64.661C42.9229 65.3298 43.1492 65.8848 43.6017 66.326C44.0542 66.7673 44.6148 66.9879 45.2836 66.9879ZM45.2845 57.8079C45.8926 57.8079 46.3961 57.6038 46.7948 57.1957C47.1942 56.7882 47.3939 56.2829 47.3939 55.6798V39.5117C47.3939 38.9092 47.1882 38.4038 46.777 37.9957C46.3657 37.5882 45.8561 37.3845 45.2479 37.3845C44.6398 37.3845 44.1364 37.5882 43.7376 37.9957C43.3382 38.4038 43.1386 38.9092 43.1386 39.5117V55.6798C43.1386 56.2829 43.3442 56.7882 43.7554 57.1957C44.1667 57.6038 44.6764 57.8079 45.2845 57.8079Z" fill="#FE5000" />
	)

	SvgPathTool = () => (
		<path d="M71.0585 79.7392C70.6835 79.7392 70.346 79.6768 70.046 79.5518C69.7454 79.4268 69.4507 79.2202 69.1619 78.9321L47.6651 57.4343C47.3763 57.1461 47.1635 56.8517 47.0266 56.5511C46.8897 56.2505 46.8213 55.9249 46.8213 55.5743C46.8213 55.1993 46.8897 54.8614 47.0266 54.5608C47.1635 54.2602 47.3763 53.9655 47.6651 53.6768L54.7685 46.5743C55.0566 46.2855 55.351 46.0727 55.6516 45.9358C55.9522 45.7989 56.2901 45.7305 56.6651 45.7305C57.0157 45.7305 57.3413 45.7989 57.6419 45.9358C57.9426 46.0727 58.2491 46.2855 58.5616 46.5743L80.0585 68.0711C80.3472 68.3599 80.5541 68.6546 80.6791 68.9552C80.8041 69.2552 80.8666 69.5927 80.8666 69.9677C80.8666 70.3427 80.8041 70.6805 80.6791 70.9811C80.5541 71.2818 80.3472 71.5761 80.0585 71.8642L72.956 78.9321C72.6672 79.2202 72.3725 79.4268 72.0719 79.5518C71.7713 79.6768 71.4335 79.7392 71.0585 79.7392ZM19.6629 79.7392C19.2879 79.7392 18.9404 79.6768 18.6204 79.5518C18.3004 79.4268 17.9963 79.2202 17.7082 78.9321L10.6629 71.9224C10.3741 71.6336 10.1672 71.3296 10.0422 71.0102C9.91724 70.6902 9.85474 70.3427 9.85474 69.9677C9.85474 69.5927 9.91724 69.2489 10.0422 68.9364C10.1672 68.6239 10.3741 68.3236 10.6629 68.0355L31.1435 47.5549H39.04L42.3504 44.2446L25.9797 27.8739H20.636L9.96255 17.2014L18.3063 8.85769L28.9797 19.5311V24.8749L45.3494 41.2446L57.3935 29.2014L50.2825 22.0905L55.0272 17.3458H45.4797L44.081 15.9827L55.1069 4.95581L56.4701 6.31894V15.903L61.2147 11.1583L77.1672 27.0377C78.0566 27.9033 78.7429 28.9155 79.226 30.0742C79.7091 31.233 79.9507 32.4517 79.9507 33.7305C79.9507 34.7399 79.7957 35.7327 79.4857 36.7089C79.1757 37.6846 78.7416 38.5811 78.1835 39.3986L70.3591 31.5742L65.0735 36.8599L60.415 32.2014L42.0035 50.6121V58.5236L21.5594 78.9321C21.2707 79.2202 20.976 79.4268 20.6754 79.5518C20.3754 79.6768 20.0379 79.7392 19.6629 79.7392Z" fill="#A7A7B2" fill-opacity="0.6" />
	)

	render() {
		const { children, iconType } = this.props;
		const iconMap = {
			tool: <this.SvgPathTool />,
			warning: <this.SvgPathWarning />,
		}
		return (
			<div className='card-cylinder-block-state' >
				<svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
					{iconMap[iconType]}
				</svg>

				<p> {children} </p>
			</div>
		)
	}
}